<template>
  <SidebarAccountsList
    v-if="content === RightDrawerContent.InsightsAccountsList"
  />
  <InsightsAssistant
    v-else-if="content === RightDrawerContent.InsightsAssistant"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDrawer } from '@app/shared/pinia/drawer'
import { RightDrawerContent } from '@app/shared/types/drawer'
import { isUsingNewLayout } from '@app/adapters/silverfin'

import SidebarAccountsList from './sidebar-accounts-list.vue'
import InsightsAssistant from './insights-assistant.vue'

const drawerStore = useDrawer()
const { rightContent, open } = storeToRefs(drawerStore)

const content = computed(() =>
  isUsingNewLayout() ? rightContent.value : open.value.content
)
</script>
